import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reportJobs } from './../../store/ReportJobs/actionCreator'
import { withStyles } from '@material-ui/core/styles'
import HeaderTitle from '../Header/HeaderTitle'
import { Helmet } from 'react-helmet'
import {
  CircularProgress,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Grid,
} from '@material-ui/core'
import {
  Report,
  VerifiedUser,
  Warning,
  Alarm,
  Loop,
  Pause,
} from '@material-ui/icons'
import { red, green, yellow } from '@material-ui/core/colors'
import { displayReadableTime } from '../../services/displayReadableTime'
import SelectTimezoneItem from './SelectTimezoneItem'
import { object, string, shape, bool, arrayOf, func } from 'prop-types'
import { useOutletContext } from 'react-router-dom'

function withOutletContext(WrappedComponent) {
  return function WrapperComponent(props) {
    const outletContext = useOutletContext()
    return <WrappedComponent {...props} outletContext={outletContext} />
  }
}

const styles = (theme) => ({
  grid: {
    flexGrow: 1,
  },
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    width: '75%',
  },
  rightDiv: {
    textAlign: 'right',
  },
  myBox: {
    width: '100%',
    margin: '0px',
    padding: '0px',
  },
  icon: {
    padding: '1px 1px 1px 5px',
    margin: '1px',
  },
  iconList: {
    padding: '0px',
    margin: '0px',
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
    }),
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  iconGood: {
    fontSize: 24,
    color: green[500],
    padding: '1px',
    margin: '1px',
  },
  iconBad: {
    fontSize: 24,
    color: red[800],
    padding: '1px',
    margin: '1px',
  },
  iconWarn: {
    fontSize: 24,
    color: yellow[800],
    padding: '1px',
    margin: '1px',
  },
  homePage: {
    textAlign: 'center',
  },
  linkButton: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
  },
  spinner: {
    color: theme.palette.primary.main,
  },
})

export class ReportingTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      selectAll: 0,
      activeStep: 0,
      blossomID: '',
      timezoneDataFromChild: '',
      // timezoneDataFromChild:
      //   this.props.timezoneData !== 'null' ? this.props.timezoneData : '',
    }
  }

  setReportData(blossomID) {
    this.props.reportJobs(blossomID)
  }

  UNSAFE_componentWillMount() {
    const { outletContext, blossomIDFromParent, timezoneData } = this.props

    if (outletContext) {
      this.setState({
        blossomID: blossomIDFromParent,
        timezoneDataFromChild: timezoneData,
      })

      this.setReportData(blossomIDFromParent)
    }
  }

  handleNext = (jobID) => {
    const { outletContext } = this.props
    const blossomID = outletContext?.blossomID || this.state.blossomID
    const jobIDFromContext = outletContext?.jobID || jobID
    return `reporting_details/${jobIDFromContext}/${blossomID}`
  }

  displayList(jsonList) {
    var rows0 = []
    var rows1 = []
    var rows2 = []
    var counter = 1
    var colums = 3
    var tempvar = ''
    const { classes } = this.props
    for (var key in jsonList) {
      // Reset colum counter
      if (counter > colums) {
        counter = 1
      }
      if (Object.prototype.hasOwnProperty.call(jsonList, key)) {
        var status = ''
        switch (jsonList[key]['status']) {
          case 'JOB_COMPLETE':
            status = <VerifiedUser className={classes.iconGood} />
            break
          case 'JOB_QUEUED':
            status = <Alarm className={classes.iconWarn} />
            break
          case 'JOB_ACTIVE':
            status = <Loop className={classes.iconWarn} />
            break
          case 'JOB_CONTACTS_COMPLETE':
            status = <VerifiedUser className={classes.iconWarn} />
            break
          case 'JOB_PAUSE':
            status = <Pause className={classes.iconWarn} />
            break
          case 'JOB_PAUSED':
            status = <Pause className={classes.iconWarn} />
            break
          case 'JOB_FILTER_IN_PROGRESS':
            status = <Warning className={classes.iconWarn} />
            break
          case 'JOB_RESUME':
            status = <Warning className={classes.iconWarn} />
            break
          case 'JOB_STOP':
            status = <Report className={classes.iconBad} />
            break
          case 'JOB_STOPPING':
            status = <Report className={classes.iconBad} />
            break
          case 'JOB_STOPPED':
            status = <Report className={classes.iconBad} />
            break
          case 'JOB_PAUSING':
            status = <Pause className={classes.iconWarn} />
            break
          case 'JOB_CREATING_HISTORY':
            status = <Warning className={classes.iconWarn} />
            break
          case 'JOB_SHADOW':
            status = <Warning className={classes.iconWarn} />
            break
          case 'JOB_STOPPED_IN_SHADOW':
            status = <Warning className={classes.iconWarn} />
            break
          case 'JOB_CONTACTS_RETRY':
            status = <Warning className={classes.iconWarn} />
            break
          default:
            status = <Report className={classes.iconBad} />
        }

        //
        tempvar = (
          <Grid item xs key={key}>
            {/* <Link
              component="button"
                variant="body2"
                onClick={() => {this.handleNext(jsonList[key]['job_id'])}}
                underline="none"
            > */}
            <a
              href={this.handleNext(jsonList[key]['job_id'])}
              className={classes.linkButton}
            >
              <ListItem divider key={key} className={classes.iconList}>
                <ListItemIcon>{status}</ListItemIcon>
                <ListItemText
                  key={key}
                  primary={jsonList[key]['message_title']}
                  secondary={
                    'Start Time: ' +
                    displayReadableTime(
                      jsonList[key]['start_time'],
                      this.state.timezoneDataFromChild,
                    )
                  }
                  className={classes.icon}
                />
              </ListItem>
            </a>
            {/* </Link> */}
          </Grid>
        )
        if (counter === 1) {
          rows0.push(tempvar)
        } else if (counter === 2) {
          rows1.push(tempvar)
        } else if (counter === 3) {
          rows2.push(tempvar)
        }
        // reset tempvar
        tempvar = ''
        counter++
      }
    }

    return (
      <div>
        <Grid container className={classes.grid} spacing={3}>
          <Grid key="0" item xs>
            <List dense key="0">
              {rows0}
            </List>
          </Grid>
          <Grid key="1" item xs>
            <List dense key="1">
              {rows1}
            </List>
          </Grid>
          <Grid key="2" item xs>
            <List dense key="2">
              {rows2}
            </List>
          </Grid>
        </Grid>
      </div>
    )
  }

  static defaultProps = {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps

    // method to see if the reports need to be refreshed
    if (
      location &&
      nextLocation &&
      nextLocation.pathname &&
      location.pathname &&
      nextLocation.pathname !== location.pathname
    ) {
      this.setState({ blossomID: nextProps.blossomIDFromParent })
      this.setReportData(nextProps.blossomIDFromParent)
    }
  }

  timezoneDataCallback = (dataFromChild) => {
    this.setState({ timezoneDataFromChild: dataFromChild })
    // this.props.setTimezoneData(dataFromChild)
  }

  render() {
    const { classes, headerTitle, fetchingState, responseData } = this.props

    let groupTitle = ''
    if (this.state.blossomID === 'bcp') {
      groupTitle = (
        <HeaderTitle title="T.O.M. - Target Outreach Manager - BCP Reporting" />
      )
    } else if (this.state.blossomID === 'c3alert') {
      groupTitle = (
        <HeaderTitle title="T.O.M. - Target Outreach Manager - C3 Reporting" />
      )
    } else if (this.state.blossomID === 'ceebackup') {
      groupTitle = <HeaderTitle title="TgtAlerts - CEE Backup Reporting" />
    } else if (this.state.blossomID === 'fmocdc') {
      groupTitle = <HeaderTitle title="TgtAlerts - FMOC DC Reporting" />
    } else if (this.state.blossomID === 'precall') {
      groupTitle = (
        <HeaderTitle title="T.O.M. - Target Outreach Manager - Product Recall Reporting" />
      )
    } else if (this.state.blossomID === 'CI00598283') {
      groupTitle = (
        <HeaderTitle title="T.O.M. - Target Outreach Manager - HR Reporting" />
      )
    } else if (this.state.blossomID === 'c3aalert') {
      groupTitle = (
        <HeaderTitle title="T.O.M. - Target Outreach Manager - C3A Reporting" />
      )
    } else if (this.state.blossomID === 'developer') {
      groupTitle = (
        <HeaderTitle title="T.O.M. - Target Outreach Manager - Developer Reporting" />
      )
    } else if (this.state.blossomID === 'shipt') {
      groupTitle = (
        <HeaderTitle title="T.O.M. - Target Outreach Manager - Shipt Reporting" />
      )
    }

    // Create variables from values of matching keys
    let toRender = <br />

    if (fetchingState === false && responseData == null) {
      toRender = (
        <div className={classes.centerDiv}>
          <Typography component="span" variant="h6">
            No Reporting Data Available
          </Typography>
        </div>
      )
    } else if (fetchingState === true) {
      toRender = (
        <div>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </div>
      )
    } else if (responseData != null) {
      toRender = (
        <div className={classes.centerDiv}>
          <Typography component="span" variant="h6">
            Select Your Report
          </Typography>
          <div className={classes.rightDiv}>
            <SelectTimezoneItem
              callbackFromParentTimezone={this.timezoneDataCallback}
              timezoneFromParent={this.state.timezoneDataFromChild}
            />
          </div>
          <form onSubmit={this.handleClick}>
            {this.displayList(responseData)}
          </form>
        </div>
      )
    }

    return (
      <div className={classes.myBox}>
        {groupTitle}
        <Helmet>
          <title>{headerTitle}</title>
        </Helmet>
        <div className={classes.homePage}>
          <br />
          {toRender}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      reportJobs,
      // setTimezoneData,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  responseData: state.reportJobs.data,
  fetchingState: state.reportJobs.fetching,
  timezoneData: state.reportJobs.timezoneData,
})

const ReportingTableWithContext = withOutletContext(ReportingTable)
const StyledConnectedReportingTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ReportingTableWithContext))

export default StyledConnectedReportingTable

ReportingTable.propTypes = {
  classes: object,
  headerTitle: string,
  fetchingState: bool,
  responseData: arrayOf(
    shape({
      job_id: string,
      status: string,
      end_time: string,
      start_time: string,
      message_title: string,
    }),
  ),
  blossomIDFromParent: string.isRequired,
  reportJobs: func,
}
